import type { ReactNode } from "react";
import { productCardDisplay, type ServerProductCardItem } from "./product-card-display";
import { ProductCardView } from "./product-card-view";

interface ServerProductCardProps {
  requestedQuantity?: number;
  item: ServerProductCardItem;
  priority?: boolean;
  sizes?: string;
  freeCollect?: boolean;
  saveSlot?: ReactNode;
  quoteHref?: string;
  phoneRow?: boolean;
}

export function ServerProductCard({
  item,
  priority = false,
  sizes,
  freeCollect = false,
  requestedQuantity,
  saveSlot,
  quoteHref,
  phoneRow,
}: ServerProductCardProps) {
  return (
    <ProductCardView
      display={productCardDisplay(item, { freeCollect, requestedQuantity })}
      priority={priority}
      sizes={sizes}
      saveSlot={saveSlot}
      quoteHref={quoteHref}
      phoneRow={phoneRow}
    />
  );
}
